import { createContext, useContext, useReducer } from 'react';
import { PoliticalPartySearchState, PoliticalPartySearchReducer, ACTION_TYPES } from './political-party-search-reducer';

const PoliticalPartySearchContext = createContext<PoliticalPartySearchState | undefined>(undefined);
const PoliticalPartySearchDispatchContext = createContext({} as any);

const PoliticalPartySearchProvider = ({ children }: { children: React.ReactNode }) => {
    const initialState: PoliticalPartySearchState = {
        parameters: { page: 0, pageSize: 25 },
        searchTrigger: 0,
        drawer: { open: false },
    };

    const [state, dispatch] = useReducer(PoliticalPartySearchReducer, initialState);

    return (
        <PoliticalPartySearchContext.Provider value={state}>
            <PoliticalPartySearchDispatchContext.Provider value={dispatch}>
                {children}
            </PoliticalPartySearchDispatchContext.Provider>
        </PoliticalPartySearchContext.Provider>
    );
};

const usePoliticalPartySearchState = () => {
    const context = useContext(PoliticalPartySearchContext);
    if (context === undefined) throw new Error('usePoliticalPartySearchState must be used within PoliticalPartySearchProvider');
    return context;
};

const usePoliticalPartySearchDispatch = () => {
    const context = useContext(PoliticalPartySearchDispatchContext);
    if (context === undefined) throw new Error('usePoliticalPartySearchDispatch must be used within PoliticalPartySearchProvider');
    return context;
};

export { PoliticalPartySearchProvider, usePoliticalPartySearchState, usePoliticalPartySearchDispatch, ACTION_TYPES };
